module.exports = {["template-constructor-control-cart_add_product_widget"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon noarrow" data-alt="Add product widget" data-alt-pos="left" data-alt-offset="9">\n		<img class="add-icon svg" src="https://d1id5eheivyv24.cloudfront.net/e8ca68c4/dist/img/constructor/controls/cart_connections/add_product_widget.svg" />\n	</div>\n';
}
return __p;
},}